/**
 * React Query hooks for the Audit Log screen. Both queries auto-refresh
 * (stats every 2 min, list every 1 min) — audit log is append-only so
 * stale-cached entries can't become wrong, only behind.
 */
import { useQuery } from '@tanstack/react-query';
import {
  AuditLogListParams,
  fetchAuditLogs,
  fetchAuditStats
} from '@/api/auditLog';

export function useAuditLogs(params: AuditLogListParams) {
  return useQuery({
    queryKey: ['auditLogs', params],
    queryFn: () => fetchAuditLogs(params),
    refetchInterval: 60_000,
    placeholderData: prev => prev
  });
}

export function useAuditStats() {
  return useQuery({
    queryKey: ['auditLogStats'],
    queryFn: fetchAuditStats,
    refetchInterval: 120_000
  });
}
